import { AxiosResponse } from "axios";
import api from "../api/base-api";

const getAllActiveVehicles = (data: Record<string, unknown>): Promise<AxiosResponse> => {
    return api.get("applications/oem/vehicles/active", { params: data });
};

const getAllOemVehicles = (data: Record<string, unknown>): Promise<AxiosResponse> => {
    return api.get("applications/oem/vehicles/all", { params: data });
};

const getAllModels = (): Promise<AxiosResponse> => {
    return api.get("/vehicles/oem/models");
};

export { getAllActiveVehicles, getAllModels, getAllOemVehicles };
